import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import OtherService from "../../services/Other";
import BigBox from "../BigBox";
import { formatNumber } from "../../constants/commonFunction";
import { addTransactionsList } from "../../redux/slices/transactionsSlice";

const RecentTransactions = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const transactionsList = useSelector((state) => state.transactions.transactionsList);
  const cachedOrderIds = useSelector((state) => state.transactions.orderIds);
  const [currentTab, setCurrentTab] = useState("all");
  const [trnasc_list, settrnasc_list] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [limit] = useState(5);
  const [loadingst, setLoadingst] = useState(false);
  const [orderIds, setOrderIds] = useState({});

  const getPoints = async () => {
    try {
      setLoadingst(true);
      const res = await OtherService.getAvailablePointsRedeemable(
        "",
        "",
        "",
        "",
        limit,
        pageNo
      );
      if (res.success) {
        const fetched = res.response.pointDetails.trnasc_list || [];
        settrnasc_list(fetched);
        const orderIdMap = {};
        fetched.forEach((txn) => {
          orderIdMap[txn.id] = txn.order_id || null;
        });
        setOrderIds(orderIdMap);
        dispatch(
          addTransactionsList({
            transactionsList: fetched,
            orderIds: orderIdMap,
          })
        );
      }
    } catch (e) {
      console.error("Error fetching transactions");
    } finally {
      setLoadingst(false);
    }
  };

  useEffect(() => {
    if (transactionsList && transactionsList.length > 0) {
      settrnasc_list(transactionsList);
      setOrderIds(cachedOrderIds);
      return;
    }
    getPoints();
  }, []);

  const renderItem = ({ item, index }) => {
    const isCredit = item.transaction_type !== "D";
    const points =
      currentTab === "tds_deduct" ? item.tds_points : item.reward_points;
    const formattedDate = new Date(item.created_at).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    });
    return (
      <Accordion.Item eventKey={index.toString()} key={index}>
        <Accordion.Header>
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    fontWeight: "bold",
                    marginBottom: "4px",
                    fontSize: "15px",
                    color: "#222",
                  }}
                >
                  {item.transaction_desc}
                  {item.comment ? ` (${item.comment})` : ""}
                </p>
                <small style={{ color: "#888" }}>{formattedDate}</small>
              </div>
              <div>
                <span
                  style={{
                    fontWeight: "bold",
                    color: isCredit ? "green" : "red",
                    fontSize: "16px",
                  }}
                >
                  {isCredit ? "+" : "-"}
                  {formatNumber(points)}
                </span>
              </div>
            </div>
          </div>
        </Accordion.Header>

        <Accordion.Body
          style={{
            backgroundColor: "#fff",
            padding: "12px 16px",
            fontSize: "14px",
            borderTop: "1px solid #eee",
          }}
        >
          <div
            style={{
              marginBottom: "8px",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            Points were credited using
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "4px 0",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <span style={{ color: "#444", fontWeight: "500" }}>Order ID</span>
            <span style={{ fontWeight: "500", color: "#222" }}>
              {orderIds[item.id] || "N/A"}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "4px 0",
              borderBottom: "1px solid #f0f0f0",
            }}
          >
            <span style={{ color: "#444", fontWeight: "500" }}>Point</span>
            <span
              style={{
                fontWeight: "500",
                // color: isCredit ? "green" : "red",
              }}
            >
              {isCredit ? "+" : "-"}
              {formatNumber(points)}
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  return (
    <div className="recent-transactions-container" style={{ padding: "16px", maxHeight: '300px', overflow: 'scroll' }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <BigBox header="Recent Transactions" />
        <button
          style={{
            background: "none",
            border: "none",
            color: "#007bff",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
          }}
          onClick={() => {
            navigate("/my-point-statement");
          }}
        >
          View All
        </button>
      </div>
      <Accordion alwaysOpen style={{ marginTop: "10px" }}>
        {trnasc_list.length > 0 ? (
          trnasc_list.map((item, index) => renderItem({ item, index }))
        ) : loadingst ? (
          <p style={{ textAlign: "center", padding: "12px" }}>Loading...</p>
        ) : (
          <p style={{ textAlign: "center", color: "#777" }}>
            No transactions found.
          </p>
        )}
      </Accordion>
    </div>
  );
};

export default RecentTransactions;
